<cmps-dialog
    class="cmps-cdk-p-0 cmps-cdk-pos-relative"
    [class.cmps-cdk-h-100p]="!_service.state?.minimized"
>
    <!-- TODO move evaluationBackgroundImage out of meetingRequestContext -->
    <!--<div
        class="cmps-ca-analysis-dialog&#45;&#45;dialog cmps-cdk-pos-absolute cmps-cdk-pos-top-0 cmps-cdk-pos-right-0 cmps-cdk-pos-bottom-0 cmps-cdk-pos-left-0 cmps-cdk-z-index-0"
        [style.background-image]="
            'url(' +
            _service.state?.meetingRequestContext?.evaluationBackgroundImage +
            ')'
        "
    >
        <div
            class="cmps-cdk-pos-absolute cmps-cdk-pos-top-0 cmps-cdk-pos-right-0 cmps-cdk-pos-bottom-0 cmps-cdk-pos-left-0"
        ></div>
    </div>-->
    <cmps-dialog-body
        class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-z-index-1"
        [class.cmps-cdk-h-100p]="_service.state?.minimized !== true"
    >
        <div class="cmps-cdk-px-1 cmps-cdk-py-0dot5">
            <div class="cmps-cdk-d-flex cmps-cdk-align-items-center">
                <div>
                    <img
                        class="cmps-ca-analysis-dialog--icai"
                        src="assets/intelligent-coach-assist-icon.svg"
                        alt=""
                        aria-hidden="true"
                    />
                </div>
                <div
                    class="cmps-cdk-ml-1 cmps-cdk-flex-grow-1 cmps-cdk-font-size-20p cmps-cdk-font-bold"
                >
                    <span>{{
                        _i18n._11191_INTELLIGENT_COACH_ASSIST_GPS | translate
                    }}</span>
                    <cmps-icon
                        class="d-inline-block cmps-cdk-ml-0dot5"
                        [class.cmps-cdk-fill-grey-400]="
                            _service.state.transcriptStatus !== 'green'
                        "
                        [class.cmps-cdk-fill-green-100]="
                            _service.state.transcriptStatus === 'green'
                        "
                        svgIcon="circle"
                    ></cmps-icon>
                </div>
                <div>
                    <button
                        cmpsIconButton
                        [cmpsTooltipTrigger]="
                            _service.state?.minimized
                                ? (_i18n._11193_MAXIMIZE | translate)
                                : (_i18n._11192_MINIMIZE | translate)
                        "
                        (click)="_onMinMaxClick()"
                    >
                        <cmps-icon
                            class="cmps-cdk-bg-color-transparent cmps-cdk-fill-grey-400 hover:cmps-cdk-fill-blue-100"
                            [svgIcon]="
                                _service.state?.minimized ? 'plus' : 'minus'
                            "
                        ></cmps-icon>
                    </button>
                    <button
                        cmpsIconButton
                        [cmpsTooltipTrigger]="_i18n._763_CLOSE | translate"
                        (click)="_dialogRef._close()"
                    >
                        <cmps-icon
                            class="cmps-cdk-bg-color-transparent cmps-cdk-fill-grey-400 hover:cmps-cdk-fill-blue-100"
                            svgIcon="close"
                        ></cmps-icon>
                    </button>
                </div>
            </div>
        </div>
        <div
            class="cmps-cdk-mb-0dot25 cmps-cdk-border-t-width-1px cmps-cdk-border-t-solid cmps-cdk-border-color-grey-300"
            *ngIf="_service.state?.minimized !== true"
        ></div>
        <div class="cmps-cdk-mb-0dot25 cmps-cdk-px-1">
            <cmps-ca-score-section
                [scorePercent]="_service.state?.result?.scorePercent"
            ></cmps-ca-score-section>
        </div>
        <div
            class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-mb-0dot25 cmps-cdk-px-1"
            *ngIf="_service.state?.minimized !== true"
        >
            <div
                class="cmps-cdk-font-bold cmps-cdk-font-size-16p cmps-cdk-flex-grow-1"
            >
                {{ _service.state?.result?.guideConfigName }}
            </div>
            <div>
                <cmps-ca-analysis-dialog-toolbar
                    [evalRef]="evalRef"
                ></cmps-ca-analysis-dialog-toolbar>
            </div>
        </div>
        <div
            class="cmps-cdk-flex-column cmps-cdk-mb-0dot5 cmps-cdk-px-1 cmps-cdk-overflow-hidden"
            [class.cmps-cdk-d-flex]="_service.state?.minimized !== true"
            [class.cmps-cdk-d-none]="_service.state?.minimized === true"
        >
            <div class="cmps-cdk-overflow-y-auto">
                <cmps-ca-evaluation
                    [caResult]="_service.state?.result"
                    [showReasoning]="false"
                    #evalRef
                ></cmps-ca-evaluation>
            </div>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
